import * as React from 'react';
import { Menu } from '../../../components/FolderHeader/menu';
import { useDispatch } from 'react-redux';
import { openModalRemove, openModalRename } from '../../../actions/folders/actions';

export function MenuContainer() {
  const dispatch = useDispatch();

  return <Menu onClickRename={() => dispatch(openModalRename())} onClickRemove={() => dispatch(openModalRemove())} />;
}
